// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictedFieldBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFieldBody component
 */
import React from 'react';
import ReactDOM from 'react-dom';
import m, { action } from 'mobx';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import Name from './Izenda.PredictedLabel';
import CalculatedFunction from './Izenda.PredictedFunction';
import PredictedModel from './Izenda.PredictedModel';
import DataType from './Izenda.PredictedDataType';
import Format from './Izenda.PredictedFormat';
import Preview from './Izenda.PredictedPreview';
import PopoverContainer from './Izenda.PopoverContainer';

@observer
class PredictedFieldBody extends React.Component {
  static displayName = 'PredictedFieldBody';

  constructor(props: Object) {
    super(props);

    this.expressionSelectionUI = m.observable({
      visible: false,
      left: 0,
      top: 0,
      cursorPosition: 0
    });
  }

  /**
   * Close expression selection popover.
   */
  closeExpressionSelection = () => {
    this.expressionSelectionUI.visible = false;
  };

  /**
   * Show expression selection popover.
   * @param {Number} position
   */
  @action
  displayExpressionSelection = (position: Number) => {
    // This method is used to show expression selection if it is hiding.
    // Otherwise, hide it.

    const textAreaDom = ReactDOM.findDOMNode(this.refs.textareaInput);
    const left = textAreaDom.offsetLeft + (position && position.left);
    const top = textAreaDom.offsetTop + (position && position.top + 90); // 90: height of bulb icon + 1 line

    // get current cursor position
    const cursorPosition = $izenda('#expressionInput').prop('selectionStart');

    const visible = !this.expressionSelectionUI.visible;

    this.expressionSelectionUI.visible = visible;
    this.expressionSelectionUI.left = left;
    this.expressionSelectionUI.top = top;
    this.expressionSelectionUI.cursorPosition = cursorPosition;
  };

  render() {
    let props = this.props;
    return (
       <div
        className="calculated-field-popup"
        onFocus={this.closeExpressionSelection}>
        <div className="calculated-field-container form-horizontal">
          <Name
            store={props.store}
            type={props.type}
            localization={props.localization}
            requireLabel={props.requireLabel}
          />  
          <CalculatedFunction
            store={props.store}
            validation={props.validation}
            type={props.type}
          />

          <PredictedModel
            store={props.store}
            validation={props.validation}
            type={props.type}
            localization={props.localization}
            validateExpression={props.validateExpression}
            ref="textareaInput"
            displayExpressionSelection={this.displayExpressionSelection}
            closeExpressionSelection={this.closeExpressionSelection}
            expressionSelectionUI={this.expressionSelectionUI}
            querySourceId={this.props.querySourceId}
          />

          <Preview
            store={props.store}
            localization={props.localization}
            validation={props.validation}
            type={props.type}
            updateError={props.updateError}
            reportDesigner={props.reportDesigner}
            reportPart={props.reportPart}
            startLoading={props.startLoading}
            endLoading={props.endLoading}
            querySourceId={props.querySourceId}
          />  
        </div>
        <PopoverContainer
          expressionConfig={props.expressionConfig}
          store={props.store}
          type={props.type}
          expressionSelectionUI={this.expressionSelectionUI}
          displayExpressionSelection={this.displayExpressionSelection}
          sourceId="expressionInput"
        />
      </div>
    );
  }
}

export default PredictedFieldBody;



// WEBPACK FOOTER //
// ./ui/share/components/controls/predictedField/Izenda.PredictedFieldBody.js